module.exports = __webpack_public_path__ + "img/avatar-1.57603767.png";